import { createTypes } from '../../utils';

// TODO Make clear namings
const types = createTypes('routing', [
    'START_ROUTE_LOADING',
    'END_ROUTE_LOADING',
    'ERRORS_ON_ROUTE_LOADING',
    'RENDER_NEXT_ROUTES_ON_CLIENT'
]);

export default types;
